import styles from "./LocationConnector.module.css";

export const LocationConnector = () => {
  return (
    <div className={styles["locationConnector"]}>
      <div className={styles["circle"]} />
      <div className={styles["dottedLine"]} />
      <div className={styles["circleFilled"]} />
    </div>
  );
};
